export const isRequired = (rules: Record<string, any> | undefined) => !!rules && Object.keys(rules).includes('required')
